import { DescriptionType } from "@usitsdasdesign/dds-ng/input";
import { SelectOptions } from "@usitsdasdesign/dds-ng/select";
import { ErrorState, Size } from "@usitsdasdesign/dds-ng/shared";
import { SuggestionsTagsInputOptions } from "@usitsdasdesign/dds-ng/suggestions-tags-input";

export const INPUT_SEARCH_OPTIONS: SuggestionsTagsInputOptions = {
  label: 'Label',
  ariaLabel: '',
  placeholder: 'Search for WBS',
  disabled: false,
  isRequired: false,
  isInverse: false,
  isError: false,
  errorMessage: '',
  errorState: ErrorState.default,
  customClass: '',
  size: Size.md,
  stickerWidth: '',
  stickerShift: 0,
  stickerMaxHeight: '18.75rem',
  stickerPosition: 'bottom',
  stickerIndent: 8,
  stickerCustomClass: '',
  stickerIsDynamic: true,
  tooltipIcon: 'dds-icon_info',
  tooltipPosition: 'right',
  tooltipIndent: 8,
  tooltipWidth: undefined,
  tooltipShift: 0,
  tooltipShowDelay: 0,
  tooltipHideDelay: 0,
  tooltipHasBeak: true,
  tooltipIsDisabled: false,
  tooltipCustomClass: '',
  tooltipTheme: 'dark',
  description: '',
  descriptionType: DescriptionType.text,
  labelPosition: 'external',
  maxHeight: '6.25rem',
  minSearchSymbols: 1,
  maxLength: 20,
};

export const selectOptionsArchive: SelectOptions = {
    placeholder: 'Select',
  };
  